import { ScheduledEmail, ScheduleFrequencyEnum } from '@module-instance/scheduled-emails/interfaces';
import { ActionEventType, ActionType, CipoTableOptions, TableRow } from '@shared/components/data-list/common';

export interface ScheduledEmailRow extends ScheduledEmail, TableRow {
  scheduleFrequencyRaw: ScheduleFrequencyEnum;
}  

export interface NewScheduledDialogData {
  scheduledEmail: ScheduledEmailRow;
  canUpdate: boolean;
}

export enum ScheduledEmailActionsEnum {
  EDIT = 1,
  TOGGLE = 2,
  DELETE = 3,
  SEND_NOW = 4,
}

export type ScheduledEmailAction = ActionType<ScheduledEmailActionsEnum, ScheduledEmailRow>;
export type ScheduledEmailActionEvent = ActionEventType<ScheduledEmailActionsEnum, ScheduledEmailRow>;
export type ScheduledEmailTableOptions = CipoTableOptions<ScheduledEmailAction>;
